var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 19,
    viewBox: "0 0 42 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.24121C1.30964 8.24121 0.75 8.80085 0.75 9.49121C0.75 10.1816 1.30964 10.7412 2 10.7412V8.24121ZM40.8839 10.3751C41.372 9.88694 41.372 9.09548 40.8839 8.60733L32.9289 0.652376C32.4408 0.164221 31.6493 0.164221 31.1612 0.652376C30.673 1.14053 30.673 1.93199 31.1612 2.42014L38.2322 9.49121L31.1612 16.5623C30.673 17.0504 30.673 17.8419 31.1612 18.33C31.6493 18.8182 32.4408 18.8182 32.9289 18.33L40.8839 10.3751ZM2 10.7412H40V8.24121H2V10.7412Z",
    fill: "#650D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a36f7fd5988f994e5815a8f485d1fd82.svg";
export { ForwardRef as ReactComponent };